import type { IconName } from "@similarweb/icons";
import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import ListIconButton from "app/pages/sales-intelligence/sub-modules/account-review/ListIconButton/ListIconButton";

import { StyledButtonWrap } from "./styles";

export type SaveToListButtonProps = {
    isDisabled?: boolean;
    isTooltipDisabled?: boolean;
    iconName?: IconName;
    btnText?: string;
    maxWidthTooltip?: number;
    onClick(): void;
} & Pick<IPlainTooltipProps, "tooltipContent">;

const SaveToListButton = (props: SaveToListButtonProps) => {
    const {
        isDisabled = false,
        isTooltipDisabled = isDisabled,
        iconName,
        maxWidthTooltip = 260,
        btnText = translate("si.multi_selector.initial_state.button.account.label"),
        tooltipContent,
        onClick,
    } = props;

    return (
        <PlainTooltip
            maxWidth={maxWidthTooltip}
            tooltipContent={tooltipContent}
            enabled={!isTooltipDisabled}
        >
            <StyledButtonWrap>
                <ListIconButton
                    dataAutomation="save-to-list-button"
                    isDisabled={isDisabled}
                    type="flat"
                    iconSize="xs"
                    iconName={iconName}
                    buttonText={btnText}
                    onClick={onClick}
                />
            </StyledButtonWrap>
        </PlainTooltip>
    );
};

export default SaveToListButton;
